import { Navigate, useParams } from 'react-router-dom';
import { PublicationStatusRedirect } from 'src/components/PublicationStatusRedirect/PublicationStatusRedirect';
import { useMenuSet } from 'src/hooks/useMenuSet';
import { Routes } from 'src/routes';

export const MenuSetPublicationStatus = () => {
  const { menuSetId } = useParams<{ menuSetId?: string }>();
  const { data, isLoading } = useMenuSet(menuSetId);
  const menuSet = data?.data[0];

  if (!menuSetId) return <Navigate to={Routes.MENU_SETS} replace />;

  return (
    <PublicationStatusRedirect
      isLoading={isLoading}
      name={menuSet?.name}
      eventId={menuSet?.publication?.event_id}
      listLabel="Menu Sets"
      listPath={Routes.MENU_SETS}
      notPublishedMessage="This menu set has not been published"
    />
  );
};
